import 'normalize.css';
import React from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import GlobalStyles from '../styles/GlobalStyles';
import Typography from '../styles/Typography';
import Footer from './Footer/Footer';
import Header from './Header/Header';
import Phone from './Phone';

const ColorStyles = styled.div`
  --brand: ${(props) => props.color};
`;

const ContentStyles = styled.div`
  position: relative;
  background: white;
  max-width: 1440px;
  margin: 0 auto;
`;
export default function MainLayout({ children, color }) {
  return (
    <ColorStyles color={color}>
      <GlobalStyles />
      <Typography />
      <Helmet>
        <html lang='ar' dir='rtl' />
      </Helmet>
      <ContentStyles>
        <Header />
        {children}
        <Phone />
      </ContentStyles>
      <Footer />
    </ColorStyles>
  );
}
